import { CountryViewModel } from '@/app/proxy/proxies';

const TURKEY_PHONE_CODE = '90';

/**
 * Turkey is the default phone country. Match the real country, not the
 * partner entries that share +90.
 */
export function findDefaultPhoneCountry(
  countries: CountryViewModel[] | null | undefined
): CountryViewModel | undefined {
  if (!countries?.length) {
    return undefined;
  }

  const turkey = countries.filter((country) => country.phoneCode?.replace(/\+/g, '') === TURKEY_PHONE_CODE);
  return (
    turkey.find((country) => country.name === 'Türkiye' || country.name === 'Turkey') ??
    turkey.find((country) => country.codeA2 === 'TR') ??
    turkey[0]
  );
}
